import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { VStack, Text, Center, Button } from '@chakra-ui/react';

function List({ items, mapKey, onClick }) {
  return (
    <VStack flex={1} w="full" gap={0}>
      {items.map(item => (
        <Center
          key={item.id || _.uniqueId()}
          as={Button}
          variant="ghost"
          borderRadius={0}
          w="full"
          h="42px"
          justifyContent="start"
          borderBottom="1px solid"
          borderColor="stroke.light"
          fontWeight="normal"
          _hover={{
            bg: 'transparent',
            textDecoration: 'none',
          }}
          onClick={() => onClick(item)}
        >
          <Text>{mapKey ? item[mapKey] : item}</Text>
        </Center>
      ))}
    </VStack>
  );
}

List.defaultProps = {
  mapKey: null,
  onClick: () => {},
};

List.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  mapKey: PropTypes.string,
  onClick: PropTypes.func,
};

export default List;
